// bgHelpers.js — Utilidades para fondos de secciones (color sólido o degradado)

// Construye el valor CSS de "background" a partir del config de una sección.
// Soporta: color sólido (color_fondo) o degradado (tipo_fondo='degradado' + color_fondo_2 + direccion_degradado).
// Si no hay color_fondo, devuelve `defaultColor` (puede ser undefined).
export function buildBg(c, defaultColor) {
  if (!c) return defaultColor;
  if (c.fondo_transparente) return 'transparent';
  const c1 = c.color_fondo || defaultColor;
  if (c.tipo_fondo === 'degradado' && c.color_fondo_2) {
    const dir = c.direccion_degradado || 'to bottom';
    return `linear-gradient(${dir}, ${c1 || '#ffffff'}, ${c.color_fondo_2})`;
  }
  // Degradado radial: la "forma" es cualquier prefijo válido de radial-gradient
  // (p. ej. `circle at center`, `ellipse at top left`, `circle closest-side`).
  if (c.tipo_fondo === 'radial' && c.color_fondo_2) {
    const forma = c.forma_degradado || 'circle at center';
    return `radial-gradient(${forma}, ${c1 || '#ffffff'}, ${c.color_fondo_2})`;
  }
  return c1;
}
